export * from './PriceLegalMentionsRepository';
